import React, { Fragment, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import NavbarAvatarMenu from "./NavbarAvatarMenu";

import {ReactComponent as IconMenu} from "../../../images/icon-menu.svg";

// const imgSiftLogo = require("../images/sift-logo.png");

const Navbar = (props) => {
  useEffect(() => { });

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(false);
  }, [])

  return (
    <nav className="o-navbar">
      <div className={`o-navbar__inner${isExpanded ? " o-navbar__inner--expanded" : ""}`}>
        <a className="o-navbar__brand" href="#">
          {/* {props.logoSrc && (
            <img src={props.logoSrc} alt="" className="o-navbar__logo-svg" />
          )} */}
          {/* {env.REACT_APP_VERSION} */}
          {/* {env.REACT_APP_BUILD_TAG} */}
          {/* <span className="o-navbar__app-title">{props.appTitle}</span> */}
          <span className="o-navbar__app-title">{props.appTitle}</span>
          <span className="o-navbar__app-title-suffix">{props.appTitleSuffix}</span>
          <span className="o-navbar__app-subtitle">{props.appSubtitle}</span>
        </a>
        <ul className="o-navbar__primary-nav-list">
          {props.navigations &&
            props.navigations.map((navItem) => (
              <li className="o-navbar__nav-item" key={navItem.path} >
                <NavLink to={navItem.path} className="o-navbar__nav-item-link" onClick={() => setIsExpanded(false)}>
                  {navItem.title}
                </NavLink>
              </li>
            ))}
        </ul>
        <div className="o-navbar__right">
          {props.children}
        </div>
        <IconMenu onClick={() => setIsExpanded(!isExpanded)} className="o-navbar__toggle" />
      </div>
    </nav>
  );
};

export default Navbar;
